import supabaseClient from "../lib/supabaseClient";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.sendupdates.ai";

const getAuthHeaders = async (): Promise<Record<string, string>> => {
  try {
    const { data } = await supabaseClient.auth.getSession();
    if (data.session?.access_token) {
      return { Authorization: `Bearer ${data.session.access_token}` };
    }
  } catch {
    // ignore
  }
  return {};
};

export const emailUpdateService = {
  async generateEmailFromInsights(insights: string[] | any[]) {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...(await getAuthHeaders()),
    };
    const res = await fetch(
      `${API_BASE_URL}/api/hybrid/emails/generate-from-insights`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({ insights }),
      }
    );
    const json = await res.json();
    if (!res.ok) throw new Error(json?.error || `HTTP ${res.status}`);
    return json?.data || json;
  },

  async sendOneOffEmail(payload: {
    contacts: Array<{ email: string; name?: string }>;
    subject: string;
    body: any; // TipTap JSON or string
  }) {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...(await getAuthHeaders()),
    };
    const res = await fetch(`${API_BASE_URL}/api/hybrid/emails/send-oneoff`, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json?.error || `HTTP ${res.status}`);
    return json?.data || json;
  },

  async sendEmailUpdate(payload: {
    subject: string;
    body: any; // TipTap JSON or string
  }) {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...(await getAuthHeaders()),
    };
    const res = await fetch(
      `${API_BASE_URL}/workflows/send-onboarding-update`,
      {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      }
    );
    const json = await res.json();
    if (!res.ok) throw new Error(json?.error || `HTTP ${res.status}`);
    return json?.data || json;
  },
};
